import { MouseEvent, ReactNode } from "react";
import { CopyIconButton } from "shared/components/CopyIconButton";
import { Show } from "shared/components/helpers/Show";

const keepClickOutOfRowLink = (event: MouseEvent<HTMLSpanElement>) => {
  event.stopPropagation();
  if (event.currentTarget.contains(event.target as Node))
    event.preventDefault();
};

export const CopyableContactRow = ({
  value,
  displayValue,
  copyAriaLabel,
  action
}: {
  value: string;
  displayValue?: string;
  copyAriaLabel: string;
  action?: ReactNode;
}) => {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="text-sm font-medium text-content-400 truncate">
        {displayValue || value}
      </span>

      <CopyIconButton
        value={value}
        idleAriaLabel={copyAriaLabel}
        strokeWidth={1}
        stopPropagation
      />
      <Show if={Boolean(action)}>
        <span className="contents" onClick={keepClickOutOfRowLink}>
          {action}
        </span>
      </Show>
    </div>
  );
};
